@if (platform.isIOS) {
  <a
    class="inline-block"
    href="https://itunes.apple.com/app/id1450796330"
    [attr.aria-label]="'echargeBanner.a11y.store-ios' | translate"
    (click)="downloadClicked.emit()"
  >
    <img
      class="block h-40 w-auto"
      src="/assets/img/logo/app-store-badge.svg"
      alt=""
      aria-hidden="true"
    />
  </a>
}
@if (platform.isAndroid) {
  <a
    class="inline-block"
    href="https://play.google.com/store/apps/details?id=com.innogy.echarge"
    [attr.aria-label]="'echargeBanner.a11y.store-android' | translate"
    (click)="downloadClicked.emit()"
  >
    <img
      class="block h-40 w-auto"
      src="/assets/img/logo/google-play-badge.svg"
      alt=""
      aria-hidden="true"
    />
  </a>
}
